module.exports = __webpack_public_path__ + "img/Mobile_notification_SVG.c7186b93.svg";